import React from 'react';

import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="cursor-pointer absolute" style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }} onClick={onClick}>
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="cursor-pointer absolute -left-30" style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }} onClick={onClick}>
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

export default function Benefits(props) {
  var settings = {
    infinite: true,
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    waitForAnimate: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          variableWidth: true,
          arrows: false,
          swipe: true,
        },
      },
    ],
    afterChange: function (a, b) {},
  };
  return (
    <Slider {...settings} className="process-slider relative z-10">
      {props.benefits.map((benefit, index) => (
        <div key={index} className="mr-30 md:pr-20">
          <div className="flex flex-row items-center mb-15">
            <img src={benefit.icon} width={10} alt={benefit.title} />
            <div className="text-black font-bold ml-10 leading-5">{benefit.title}</div>
          </div>

          <div>{benefit.text}</div>
        </div>
      ))}
    </Slider>
  );
}
